import { InterweaveProps } from 'interweave';
import dynamic from 'next/dynamic';
import { ComponentType, FC } from 'react';

const BaseInterweave: ComponentType<InterweaveProps> = dynamic(() => import('interweave').then(mod => mod.Interweave), {
  ssr: false
});

export const Interweave: FC<InterweaveProps> = ({ ...props }) => {
  // 统一处理公共场景
  return <BaseInterweave {...props} />;
};
